import React from "react";
import { css } from "glamor";
import formatDate from "../../utils/formatDate";
import { toBRLCurrency } from "../../utils/formatCurrency";
import {
  purchaseStatusVariant,
  purchasePeriodText,
} from "./financeSubscriptionHelpers";

const paymentHistoryClass = css({
  marginTop: 10,
  border: "0.6px solid #E2E8F0",
  borderRadius: 8,
  overflow: "hidden",
  background: "#FFFFFF",
});

const paymentHistoryHeaderClass = css({
  display: "grid",
  gridTemplateColumns: "1fr 0.8fr 0.65fr",
  gap: 10,
  padding: "8px 12px",
  background: "#F8FAFC",
  color: "#94A3B8",
  fontSize: 10,
  fontWeight: 600,
  lineHeight: "15px",
  textTransform: "uppercase",
  "@media(max-width: 560px)": {
    display: "none",
  },
});

const paymentHistoryRowClass = css({
  display: "grid",
  gridTemplateColumns: "1fr 0.8fr 0.65fr",
  alignItems: "center",
  gap: 10,
  padding: "10px 12px",
  color: "#0F172A",
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "18px",
  ":not(:last-child)": {
    borderBottom: "0.6px solid #F1F5F9",
  },
  "@media(max-width: 560px)": {
    gridTemplateColumns: "1fr",
    gap: 3,
  },
});

const paymentHistoryCellClass = css({
  minWidth: 0,
  overflowWrap: "anywhere",
  "@media(max-width: 560px)": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    ":before": {
      content: "attr(data-label)",
      color: "#94A3B8",
      fontSize: 10,
      fontWeight: 600,
      lineHeight: "15px",
      textTransform: "uppercase",
    },
  },
});

const paymentHistoryDateSubClass = css({
  display: "block",
  color: "#94A3B8",
  fontSize: 10,
  fontWeight: 400,
  lineHeight: "15px",
  "@media(max-width: 560px)": {
    display: "none",
  },
});

const paymentHistoryValueClass = css({
  fontWeight: 500,
});

const paymentStatusClass = (variant) => css({
  justifySelf: "flex-start",
  display: "inline-flex",
  alignItems: "center",
  minHeight: 20,
  padding: "0 7px",
  borderRadius: 4,
  border: `0.6px solid ${variant.border}`,
  background: variant.background,
  color: variant.color,
  fontSize: 10,
  fontWeight: 500,
  lineHeight: "15px",
  whiteSpace: "nowrap",
  "@media(max-width: 560px)": {
    justifySelf: "auto",
  },
});

const paymentHistoryEmptyClass = css({
  padding: "10px 12px",
  color: "#64748B",
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "18px",
});

export default function PaymentHistory({ purchases = [] }) {
  if (!purchases.length) {
    return (
      <div className={paymentHistoryClass}>
        <div className={paymentHistoryEmptyClass}>Nenhum pagamento encontrado.</div>
      </div>
    );
  }

  return (
    <div className={paymentHistoryClass}>
      <div className={paymentHistoryHeaderClass}>
        <span>Data</span>
        <span>Valor</span>
        <span>Status</span>
      </div>

      {purchases.map((purchase) => {
        const status = purchaseStatusVariant(purchase);

        return (
          <div className={paymentHistoryRowClass} key={purchase.id}>
            <span className={paymentHistoryCellClass} data-label="Data">
              {purchase.createdAt ? formatDate(purchase.createdAt, "DD/MM/YYYY") : "-"}
              {purchasePeriodText(purchase) && (
                <span className={paymentHistoryDateSubClass}>{purchasePeriodText(purchase)}</span>
              )}
            </span>
            <span className={paymentHistoryCellClass} data-label="Valor">
              <span className={paymentHistoryValueClass}>{toBRLCurrency(purchase.productPrice)}</span>
            </span>
            <span className={paymentHistoryCellClass} data-label="Status">
              <span className={paymentStatusClass(status)}>{status.text}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
